import { Instance, types } from 'mobx-state-tree'

export const ShareModel = types.model({
  hash: types.string,
  message: types.string,
  url: types.string
})

export type ShareModelType = Instance<typeof ShareModel>
